// ==================== NEET TESTS METADATA ====================
export const freeNEETTestsMetadata = {
  // ✅ 200-question pattern (2021+)
  'neet2022q1': {
    id: 'neet2022q1',
    testName: 'NEET 2022, Paper Code Q1',
    year: '2022',
    examName: 'NEET 2022',
    subject: 'Paper Code Q1',
    duration: 3 * 60 * 60,
    totalQuestions: 200,
    storagePath: 'PYQTestSeries/Neet/neet2022q1',
    backLink: '/test-series/pyq/neet',
    questionCounts: {
  Physics: 50,
  Chemistry: 50,
  Biology: 100,
},
answerKey: {
  Physics: {
    1: "4", 2: "2", 3: "2", 4: "4", 5: "3", 6: "4", 7: "3", 8: "2", 9: "3", 10: "3",
    11: "3", 12: "3", 13: "2", 14: "1", 15: "3", 16: "3", 17: "4", 18: "2", 19: "3", 20: "3",
    21: "2", 22: "3", 23: "1", 24: "4", 25: "2", 26: "2", 27: "3", 28: "2", 29: "3", 30: "4",
    31: "2", 32: "4", 33: "4", 34: "1", 35: "4", 36: "2", 37: "1", 38: "4", 39: "2", 40: "3",
    41: "3", 42: "2", 43: "2", 44: "3", 45: "3", 46: "4", 47: "3", 48: "2", 49: "2", 50: "3"
  },
  Chemistry: {
    1: "2", 2: "1", 3: "4", 4: "1", 5: "2", 6: "1", 7: "3", 8: "4", 9: "2", 10: "4",
    11: "4", 12: "1", 13: "2", 14: "2", 15: "3", 16: "3", 17: "1", 18: "4", 19: "3", 20: "3",
    21: "2", 22: "4", 23: "3", 24: "4", 25: "3", 26: "4", 27: "3", 28: "4", 29: "2", 30: "1",
    31: "1", 32: "2", 33: "1", 34: "4", 35: "4", 36: "3", 37: "1", 38: "2", 39: "4", 40: "1",
    41: "2", 42: "1", 43: "Question is dropped", 44: "4", 45: "3", 46: "2", 47: "1", 48: "1", 49: "1", 50: "2"
  },
  Biology: {
    1: "2", 2: "3", 3: "3", 4: "3", 5: "2", 6: "2", 7: "1", 8: "2", 9: "3", 10: "1",
    11: "2", 12: "3", 13: "3", 14: "2", 15: "3", 16: "4", 17: "3", 18: "3", 19: "2", 20: "2",
    21: "3", 22: "1", 23: "3", 24: "2", 25: "3", 26: "2", 27: "2", 28: "2", 29: "4", 30: "3",
    31: "3", 32: "4", 33: "1", 34: "3", 35: "1", 36: "2", 37: "1", 38: "3", 39: "2", 40: "1",
    41: "2", 42: "2", 43: "3", 44: "2", 45: "3", 46: "2", 47: "1", 48: "3", 49: "2", 50: "2",
    51: "1", 52: "4", 53: "1", 54: "1", 55: "3", 56: "4", 57: "3", 58: "1", 59: "3", 60: "2",
    61: "1", 62: "4", 63: "4", 64: "2", 65: "3", 66: "1", 67: "1", 68: "3", 69: "4", 70: "4",
    71: "3", 72: "3", 73: "2", 74: "2", 75: "3", 76: "1", 77: "2", 78: "4", 79: "3", 80: "1",
    81: "2", 82: "2", 83: "4", 84: "2", 85: "2", 86: "4", 87: "4", 88: "2", 89: "3", 90: "4",
    91: "3", 92: "4", 93: "2", 94: "4", 95: "4", 96: "4", 97: "1", 98: "2", 99: "1", 100: "4"
  }
}
  },
  
  'neet2022r1': {
    id: 'neet2022r1',
    testName: 'NEET 2022, Paper Code R1',
    year: '2022',
    examName: 'NEET 2022',
    subject: 'Paper Code R1',
    duration: 3 * 60 * 60,
    totalQuestions: 200,
    storagePath: 'PYQTestSeries/Neet/neet2022r1',
    backLink: '/test-series/pyq/neet',
    questionCounts: {
  Physics: 50,
  Chemistry: 50,
  Biology: 100,
},
answerKey: {
  Physics: {
    1: "4", 2: "4", 3: "1", 4: "2", 5: "4", 6: "1", 7: "2", 8: "2", 9: "3", 10: "3",
    11: "1", 12: "3", 13: "4", 14: "4", 15: "1", 16: "3", 17: "3", 18: "4", 19: "4", 20: "3",
    21: "3", 22: "4", 23: "1", 24: "3", 25: "4", 26: "1", 27: "4", 28: "4", 29: "4", 30: "1",
    31: "1", 32: "1", 33: "3", 34: "3", 35: "4", 36: "2", 37: "3", 38: "4", 39: "3", 40: "4",
    41: "3", 42: "4", 43: "4", 44: "1", 45: "4", 46: "3", 47: "3", 48: "4", 49: "3", 50: "1"
  },
  Chemistry: {
    1: "2", 2: "4", 3: "2", 4: "1", 5: "4", 6: "2", 7: "3", 8: "4", 9: "4", 10: "1",
    11: "1", 12: "3", 13: "4", 14: "2", 15: "3", 16: "2", 17: "2", 18: "1", 19: "3", 20: "1",
    21: "4", 22: "1", 23: "3", 24: "4", 25: "3", 26: "3", 27: "2", 28: "1", 29: "1", 30: "1",
    31: "2", 32: "1", 33: "1", 34: "3", 35: "4", 36: "2", 37: "Question is dropped", 38: "3", 39: "2", 40: "3",
    41: "2", 42: "3", 43: "2", 44: "3", 45: "1", 46: "2", 47: "4", 48: "4", 49: "1", 50: "2"
  },
  Biology: {
    1: "3", 2: "4", 3: "4", 4: "3", 5: "1", 6: "4", 7: "4", 8: "4", 9: "4", 10: "1",
    11: "3", 12: "2", 13: "4", 14: "1", 15: "4", 16: "3", 17: "4", 18: "2", 19: "4", 20: "4",
    21: "2", 22: "3", 23: "3", 24: "3", 25: "3", 26: "2", 27: "3", 28: "4", 29: "4", 30: "2",
    31: "3", 32: "3", 33: "4", 34: "4", 35: "3", 36: "3", 37: "3", 38: "4", 39: "2", 40: "2",
    41: "3", 42: "2", 43: "4", 44: "3", 45: "3", 46: "4", 47: "3", 48: "3", 49: "3", 50: "4",
    51: "2", 52: "1", 53: "2", 54: "2", 55: "1", 56: "2", 57: "4", 58: "1", 59: "1", 60: "4",
    61: "3", 62: "1", 63: "3", 64: "2", 65: "1", 66: "3", 67: "4", 68: "4", 69: "2", 70: "4",
    71: "2", 72: "3", 73: "3", 74: "4", 75: "1", 76: "3", 77: "4", 78: "3", 79: "1", 80: "3",
    81: "4", 82: "2", 83: "2", 84: "3", 85: "4", 86: "3", 87: "1", 88: "1", 89: "1", 90: "1",
    91: "2", 92: "3", 93: "1", 94: "1", 95: "3", 96: "4", 97: "2", 98: "1", 99: "1", 100: "4"
  }
}
  },
  // 2023 Tests
  'neet2023e1': {
    id: 'neet2023e1',
    testName: 'NEET 2023, Paper Code E1',
    year: '2023',
    examName: 'NEET 2023',
    subject: 'Paper Code E1',
    duration: 3 * 60 * 60,
    totalQuestions: 200,
    storagePath: 'PYQTestSeries/Neet/neet2023e1',
    backLink: '/test-series/pyq/neet',
    questionCounts: {
  Physics: 50,
  Chemistry: 50,
  Biology: 100,
},
answerKey: {
  Physics: {
    1: "2", 2: "Question is dropped", 3: "1", 4: "3", 5: "1", 6: "4", 7: "3", 8: "1", 9: "3", 10: "4",
    11: "3", 12: "1", 13: "4", 14: "4", 15: "1", 16: "3", 17: "3", 18: "3", 19: "2", 20: "4",
    21: "3", 22: "3", 23: "2", 24: "3", 25: "3", 26: "2", 27: "1", 28: "4", 29: "4", 30: "2",
    31: "2", 32: "4", 33: "2", 34: "1", 35: "3", 36: "4", 37: "3", 38: "4", 39: "1", 40: "1",
    41: "3", 42: "2", 43: "3", 44: "2", 45: "3", 46: "2", 47: "3", 48: "3", 49: "4", 50: "3"
  },
  Chemistry: {
    1: "3", 2: "3", 3: "3", 4: "4", 5: "3", 6: "4", 7: "4", 8: "3", 9: "2", 10: "3",
    11: "1", 12: "3", 13: "1", 14: "1", 15: "1", 16: "3", 17: "3", 18: "3", 19: "2", 20: "4",
    21: "3", 22: "4", 23: "1", 24: "3", 25: "1", 26: "2", 27: "3", 28: "1", 29: "4", 30: "1",
    31: "4", 32: "2", 33: "2", 34: "3", 35: "1", 36: "2", 37: "3", 38: "3", 39: "1", 40: "3",
    41: "2", 42: "1", 43: "3", 44: "3", 45: "3", 46: "1", 47: "2", 48: "4", 49: "3", 50: "1"
  },
  Biology: {
    1: "1", 2: "3", 3: "4", 4: "1", 5: "3", 6: "3", 7: "1", 8: "4", 9: "1", 10: "4",
    11: "2", 12: "1", 13: "2", 14: "2", 15: "2", 16: "3", 17: "2", 18: "1", 19: "1", 20: "1",
    21: "1", 22: "1", 23: "1", 24: "3", 25: "2", 26: "2", 27: "3", 28: "2", 29: "2", 30: "2",
    31: "2", 32: "3", 33: "4", 34: "3", 35: "1", 36: "2", 37: "1", 38: "3", 39: "4", 40: "1",
    41: "3", 42: "1", 43: "1", 44: "1", 45: "2", 46: "3", 47: "2", 48: "3", 49: "3", 50: "1 & 3",
    51: "2", 52: "1", 53: "2", 54: "2", 55: "2", 56: "1", 57: "2", 58: "4", 59: "2", 60: "1",
    61: "1", 62: "2", 63: "1", 64: "1", 65: "3", 66: "2", 67: "1", 68: "2", 69: "4", 70: "1",
    71: "2", 72: "4", 73: "4", 74: "1", 75: "4", 76: "2", 77: "2", 78: "3", 79: "3", 80: "3",
    81: "3", 82: "1", 83: "2", 84: "1", 85: "4", 86: "1", 87: "2", 88: "1", 89: "2", 90: "3",
    91: "2", 92: "3", 93: "2", 94: "3", 95: "3", 96: "4", 97: "4", 98: "2", 99: "2", 100: "3"
  }
}
  },
  'neet2023f1': {
    id: 'neet2023f1',
    testName: 'NEET 2023, Paper Code F1',
    year: '2023',
    examName: 'NEET 2023',
    subject: 'Paper Code F1',
    duration: 3 * 60 * 60,
    totalQuestions: 200,
    storagePath: 'PYQTestSeries/Neet/neet2023f1',
    backLink: '/test-series/pyq/neet',
    questionCounts: {
  Physics: 50,
  Chemistry: 50,
  Biology: 100,
},
answerKey: {
  Physics: {
    1: "Question is dropped", 2: "4", 3: "2", 4: "2", 5: "3", 6: "2", 7: "4", 8: "3", 9: "4", 10: "2",
    11: "2", 12: "1", 13: "1", 14: "2", 15: "2", 16: "2", 17: "3", 18: "3", 19: "4", 20: "2",
    21: "1", 22: "3", 23: "2", 24: "4", 25: "4", 26: "2", 27: "3", 28: "1", 29: "4", 30: "3",
    31: "1", 32: "3", 33: "1", 34: "1", 35: "2", 36: "4", 37: "3", 38: "2", 39: "1", 40: "2",
    41: "2", 42: "1", 43: "3", 44: "1", 45: "2", 46: "2", 47: "4", 48: "2", 49: "2", 50: "3"
  },
  Chemistry: {
    1: "2", 2: "3", 3: "1", 4: "3", 5: "3", 6: "4", 7: "2", 8: "2", 9: "4", 10: "4",
    11: "4", 12: "4", 13: "3", 14: "2", 15: "3", 16: "2", 17: "2", 18: "4", 19: "2", 20: "2",
    21: "2", 22: "4", 23: "4", 24: "2", 25: "2", 26: "2", 27: "3", 28: "4", 29: "1", 30: "3",
    31: "1", 32: "2", 33: "1", 34: "1", 35: "2", 36: "1", 37: "2", 38: "2", 39: "1", 40: "4",
    41: "2", 42: "2", 43: "2", 44: "4", 45: "2", 46: "4", 47: "3", 48: "4", 49: "2", 50: "1"
  },
  Biology: {
    1: "2", 2: "3", 3: "4", 4: "1", 5: "1", 6: "1", 7: "1", 8: "2", 9: "2", 10: "2",
    11: "4", 12: "1", 13: "4", 14: "3", 15: "1", 16: "4", 17: "1", 18: "4", 19: "4", 20: "1",
    21: "2", 22: "4", 23: "3", 24: "4", 25: "1", 26: "4", 27: "4", 28: "2", 29: "4", 30: "2",
    31: "2", 32: "4", 33: "1", 34: "3", 35: "1", 36: "2", 37: "1", 38: "4", 39: "2", 40: "1",
    41: "2", 42: "2", 43: "2", 44: "1", 45: "4", 46: "4", 47: "4", 48: "3", 49: "4", 50: "2 & 4",
    51: "3", 52: "3", 53: "4", 54: "3", 55: "1", 56: "4", 57: "4", 58: "4", 59: "4", 60: "4",
    61: "1", 62: "1", 63: "3", 64: "4", 65: "1", 66: "2", 67: "2", 68: "4", 69: "1", 70: "2",
    71: "4", 72: "2", 73: "1", 74: "1", 75: "1", 76: "4", 77: "3", 78: "1", 79: "1", 80: "3",
    81: "4", 82: "1", 83: "1", 84: "1", 85: "2", 86: "1", 87: "1", 88: "1", 89: "3", 90: "3",
    91: "4", 92: "2", 93: "1", 94: "1", 95: "2", 96: "2", 97: "4", 98: "2", 99: "2", 100: "1"
  }
}
  },
  'neet2023g1': {
    id: 'neet2023g1',
    testName: 'NEET 2023, Paper Code G1',
    year: '2023',
    examName: 'NEET 2023',
    subject: 'Paper Code G1',
    duration: 3 * 60 * 60,
    totalQuestions: 200,
    storagePath: 'PYQTestSeries/Neet/neet2023g1',
    backLink: '/test-series/pyq/neet',
    questionCounts: {
  Physics: 50,
  Chemistry: 50,
  Biology: 100,
},
answerKey: {
  Physics: {
    1: "4", 2: "1", 3: "4", 4: "3", 5: "1", 6: "4", 7: "4", 8: "3", 9: "1", 10: "4",
    11: "1", 12: "Question is dropped", 13: "2", 14: "2", 15: "2", 16: "2", 17: "4", 18: "3", 19: "1", 20: "3",
    21: "2", 22: "2", 23: "4", 24: "4", 25: "4", 26: "4", 27: "4", 28: "1", 29: "3", 30: "2",
    31: "4", 32: "3", 33: "1", 34: "1", 35: "3", 36: "4", 37: "4", 38: "4", 39: "2", 40: "3",
    41: "3", 42: "4", 43: "4", 44: "2", 45: "3", 46: "1", 47: "4", 48: "1", 49: "4", 50: "1"
  },
  Chemistry: {
    1: "4", 2: "4", 3: "4", 4: "1", 5: "3", 6: "1", 7: "4", 8: "3", 9: "4", 10: "3",
    11: "3", 12: "4", 13: "1", 14: "1", 15: "4", 16: "2", 17: "4", 18: "2", 19: "4", 20: "4",
    21: "2", 22: "4", 23: "2", 24: "1", 25: "2", 26: "2", 27: "4", 28: "1", 29: "2", 30: "2",
    31: "1", 32: "4", 33: "4", 34: "2", 35: "4", 36: "4", 37: "4", 38: "4", 39: "2", 40: "4",
    41: "4", 42: "4", 43: "3", 44: "3", 45: "4", 46: "1", 47: "2", 48: "3", 49: "2", 50: "2"
  },
  Biology: {
    1: "1", 2: "2", 3: "2", 4: "4", 5: "3", 6: "1", 7: "2", 8: "4", 9: "1", 10: "3",
    11: "4", 12: "2", 13: "2", 14: "2", 15: "3", 16: "3", 17: "3", 18: "4", 19: "1", 20: "3",
    21: "3", 22: "2", 23: "2", 24: "3", 25: "4", 26: "2", 27: "4", 28: "3", 29: "2", 30: "3",
    31: "4", 32: "3", 33: "3", 34: "2", 35: "2", 36: "2", 37: "2", 38: "2", 39: "4", 40: "2",
    41: "3", 42: "4", 43: "4", 44: "4", 45: "3", 46: "2 & 4", 47: "3", 48: "2", 49: "4", 50: "1",
    51: "4", 52: "2", 53: "4", 54: "3", 55: "2", 56: "1", 57: "3", 58: "1", 59: "3", 60: "2",
    61: "1", 62: "2", 63: "1", 64: "4", 65: "3", 66: "3", 67: "2", 68: "3", 69: "1", 70: "1",
    71: "3", 72: "2", 73: "2", 74: "3", 75: "3", 76: "3", 77: "2", 78: "4", 79: "2", 80: "3",
    81: "3", 82: "3", 83: "4", 84: "2", 85: "2", 86: "3", 87: "3", 88: "4", 89: "1", 90: "4",
    91: "4", 92: "4", 93: "3", 94: "3", 95: "1", 96: "3", 97: "2", 98: "2", 99: "4", 100: "3"
  }
}
  },
  // 2024 Tests
  'neet2024q1': {
    id: 'neet2024q1',
    testName: 'NEET 2024, Paper Code Q1',
    year: '2024',
    examName: 'NEET 2024',
    subject: 'Paper Code Q1',
    duration: 3 * 60 * 60,
    totalQuestions: 200,
    storagePath: 'PYQTestSeries/Neet/neet2024q1',
    backLink: '/test-series/pyq/neet',
    questionCounts: {
  Physics: 50,
  Chemistry: 50,
  Biology: 100,
},
answerKey: {
  Physics: {
    1: "3", 2: "2", 3: "1", 4: "1", 5: "3", 6: "2", 7: "4", 8: "4", 9: "1", 10: "4",
    11: "3", 12: "1", 13: "1", 14: "1", 15: "2", 16: "4", 17: "3", 18: "1", 19: "1 & 3", 20: "4",
    21: "4", 22: "2", 23: "2", 24: "3", 25: "2", 26: "4", 27: "2", 28: "1", 29: "2", 30: "1",
    31: "4", 32: "2", 33: "3", 34: "1", 35: "2", 36: "2", 37: "2", 38: "2", 39: "4", 40: "1",
    41: "4", 42: "1", 43: "2", 44: "2", 45: "2", 46: "2", 47: "3", 48: "2", 49: "2", 50: "2"
  },
  Chemistry: {
    1: "1", 2: "2", 3: "4", 4: "3", 5: "1", 6: "4", 7: "1", 8: "3", 9: "1", 10: "3",
    11: "1", 12: "4", 13: "1", 14: "3", 15: "1", 16: "4", 17: "2", 18: "1", 19: "1", 20: "1",
    21: "4", 22: "2", 23: "1", 24: "3", 25: "3", 26: "4", 27: "1", 28: "1", 29: "1", 30: "4",
    31: "2", 32: "4", 33: "2", 34: "3", 35: "2", 36: "4", 37: "1", 38: "1", 39: "4", 40: "4",
    41: "2", 42: "2", 43: "1", 44: "1", 45: "1", 46: "1", 47: "1", 48: "2", 49: "4", 50: "2"
  },
  Biology: {
    1: "1", 2: "3", 3: "2", 4: "3", 5: "4", 6: "3", 7: "4", 8: "3", 9: "2", 10: "1",
    11: "1", 12: "1", 13: "1", 14: "2", 15: "4", 16: "4", 17: "3", 18: "3", 19: "4", 20: "2",
    21: "1", 22: "3", 23: "1", 24: "1", 25: "4", 26: "3", 27: "2", 28: "3", 29: "3", 30: "2",
    31: "2", 32: "3", 33: "1", 34: "2", 35: "4", 36: "2", 37: "1", 38: "2", 39: "2", 40: "1",
    41: "3", 42: "3", 43: "3", 44: "1", 45: "1", 46: "2", 47: "3", 48: "3", 49: "2", 50: "4",
    51: "4", 52: "3", 53: "3", 54: "1", 55: "4", 56: "2", 57: "1", 58: "3", 59: "2", 60: "4",
    61: "3", 62: "1", 63: "4", 64: "4", 65: "2", 66: "3", 67: "3", 68: "2", 69: "4", 70: "4",
    71: "4", 72: "2", 73: "1", 74: "2", 75: "1", 76: "4", 77: "3", 78: "2", 79: "2", 80: "2",
    81: "2", 82: "3", 83: "2", 84: "3", 85: "4", 86: "4", 87: "3", 88: "3", 89: "1", 90: "4",
    91: "3", 92: "1", 93: "3", 94: "4", 95: "3", 96: "2", 97: "1", 98: "1", 99: "1", 100: "4"
  }
}
  },
  'neet2024r1': {
    id: 'neet2024r1',
    testName: 'NEET 2024, Paper Code R1',
    year: '2024',
    examName: 'NEET 2024',
    subject: 'Paper Code R1',
    duration: 3 * 60 * 60,
    totalQuestions: 200,
    storagePath: 'PYQTestSeries/Neet/neet2024r1',
    backLink: '/test-series/pyq/neet',
    questionCounts: {
  Physics: 50,
  Chemistry: 50,
  Biology: 100,
},
answerKey: {
  Physics: {
    1: "1", 2: "1", 3: "4", 4: "2", 5: "1", 6: "1", 7: "4", 8: "4", 9: "2", 10: "3",
    11: "2", 12: "2 & 4", 13: "4", 14: "4", 15: "3", 16: "1", 17: "1", 18: "3", 19: "3", 20: "4",
    21: "2", 22: "4", 23: "1", 24: "4", 25: "4", 26: "2", 27: "3", 28: "1", 29: "1", 30: "4",
    31: "2", 32: "1", 33: "3", 34: "3", 35: "3", 36: "4", 37: "1", 38: "2", 39: "1", 40: "1",
    41: "1", 42: "1", 43: "3", 44: "4", 45: "1", 46: "1", 47: "3", 48: "3", 49: "1", 50: "1"
  },
  Chemistry: {
    1: "2", 2: "4", 3: "3", 4: "3", 5: "2", 6: "4", 7: "2", 8: "1", 9: "2", 10: "4",
    11: "3", 12: "4", 13: "4", 14: "2", 15: "1", 16: "4", 17: "2", 18: "4", 19: "4", 20: "4",
    21: "3", 22: "4", 23: "2", 24: "1", 25: "3", 26: "3", 27: "4", 28: "1", 29: "4", 30: "1",
    31: "3", 32: "4", 33: "1", 34: "4", 35: "3", 36: "1", 37: "3", 38: "4", 39: "4", 40: "1",
    41: "4", 42: "3", 43: "4", 44: "3", 45: "4", 46: "1", 47: "1", 48: "4", 49: "4", 50: "3"
  },
  Biology: {
    1: "2", 2: "1", 3: "2", 4: "3", 5: "3", 6: "2", 7: "2", 8: "1", 9: "2", 10: "3",
    11: "4", 12: "1", 13: "3", 14: "4", 15: "1", 16: "2", 17: "1", 18: "4", 19: "2", 20: "2",
    21: "1", 22: "2", 23: "2", 24: "3", 25: "4", 26: "4", 27: "4", 28: "2", 29: "1", 30: "4",
    31: "3", 32: "3", 33: "2", 34: "4", 35: "4", 36: "2", 37: "1", 38: "2", 39: "1", 40: "2",
    41: "2", 42: "1", 43: "1", 44: "4", 45: "4", 46: "4", 47: "2", 48: "1", 49: "4", 50: "3",
    51: "1", 52: "4", 53: "2", 54: "4", 55: "3", 56: "2", 57: "3", 58: "1", 59: "2", 60: "3",
    61: "1", 62: "1", 63: "2", 64: "2", 65: "2", 66: "1", 67: "1", 68: "2", 69: "1", 70: "1",
    71: "3", 72: "1", 73: "3", 74: "3", 75: "4", 76: "3", 77: "3", 78: "4", 79: "3", 80: "3",
    81: "1", 82: "2", 83: "4", 84: "2", 85: "1", 86: "2", 87: "2", 88: "4", 89: "1", 90: "4",
    91: "3", 92: "3", 93: "4", 94: "4", 95: "3", 96: "3", 97: "2", 98: "4", 99: "2", 100: "2"
  }
}
  },
  'neet2024s1': {
    id: 'neet2024s1',
    testName: 'NEET 2024, Paper Code S1',
    year: '2024',
    examName: 'NEET 2024',
    subject: 'Paper Code S1',
    duration: 3 * 60 * 60,
    totalQuestions: 200,
    storagePath: 'PYQTestSeries/Neet/neet2024s1',
    backLink: '/test-series/pyq/neet',
    questionCounts: {
  Physics: 50,
  Chemistry: 50,
  Biology: 100,
},
answerKey: {
  Physics: {
    1: "3", 2: "3", 3: "2", 4: "4", 5: "1", 6: "3", 7: "1", 8: "3", 9: "3", 10: "2",
    11: "2", 12: "3", 13: "4", 14: "3", 15: "1", 16: "2", 17: "1", 18: "1", 19: "2", 20: "2 & 4",
    21: "3", 22: "2", 23: "2", 24: "4", 25: "3", 26: "4", 27: "4", 28: "3", 29: "1", 30: "2",
    31: "1", 32: "2", 33: "1", 34: "2", 35: "4", 36: "1", 37: "4", 38: "3", 39: "1", 40: "2",
    41: "3", 42: "3", 43: "3", 44: "2", 45: "3", 46: "3", 47: "3", 48: "3", 49: "3", 50: "3"
  },
  Chemistry: {
    1: "3", 2: "1", 3: "4", 4: "2", 5: "2", 6: "3", 7: "4", 8: "3", 9: "2", 10: "1",
    11: "2", 12: "2", 13: "1", 14: "2", 15: "2", 16: "3", 17: "1", 18: "2", 19: "4", 20: "2",
    21: "4", 22: "4", 23: "4", 24: "4", 25: "2", 26: "1", 27: "3", 28: "3", 29: "2", 30: "2",
    31: "2", 32: "1", 33: "1", 34: "2", 35: "1", 36: "2", 37: "2", 38: "1", 39: "3", 40: "2",
    41: "2", 42: "1", 43: "1", 44: "2", 45: "2", 46: "3", 47: "1", 48: "3", 49: "2", 50: "3"
  },
  Biology: {
    1: "3", 2: "1", 3: "3", 4: "1", 5: "1", 6: "2", 7: "2", 8: "2", 9: "4", 10: "2",
    11: "1", 12: "1", 13: "1", 14: "1", 15: "4", 16: "4", 17: "4", 18: "3", 19: "2", 20: "2",
    21: "3", 22: "3", 23: "4", 24: "3", 25: "4", 26: "2", 27: "3", 28: "1", 29: "2", 30: "3",
    31: "4", 32: "4", 33: "4", 34: "2", 35: "4", 36: "2", 37: "4", 38: "2", 39: "4", 40: "4",
    41: "3", 42: "3", 43: "4", 44: "3", 45: "2", 46: "1", 47: "4", 48: "2", 49: "3", 50: "3",
    51: "3", 52: "1", 53: "3", 54: "3", 55: "3", 56: "1", 57: "3", 58: "3", 59: "4", 60: "1",
    61: "2", 62: "1", 63: "1", 64: "3", 65: "4", 66: "1", 67: "4", 68: "2", 69: "2", 70: "2",
    71: "1", 72: "4", 73: "3", 74: "3", 75: "2", 76: "1", 77: "4", 78: "3", 79: "4", 80: "4",
    81: "2", 82: "4", 83: "3", 84: "4", 85: "1", 86: "4", 87: "2", 88: "1", 89: "3", 90: "1",
    91: "4", 92: "2", 93: "4", 94: "4", 95: "2", 96: "2", 97: "4", 98: "1", 99: "1", 100: "2"
  }
}
  },
  'neet2024t1': {
    id: 'neet2024t1',
    testName: 'NEET 2024, Paper Code T1',
    year: '2024',
    examName: 'NEET 2024',
    subject: 'Paper Code T1',
    duration: 3 * 60 * 60,
    totalQuestions: 200,
    storagePath: 'PYQTestSeries/Neet/neet2024t1',
    backLink: '/test-series/pyq/neet',
    questionCounts: {
  Physics: 50,
  Chemistry: 50,
  Biology: 100,
},
answerKey: {
  Physics: {
    1: "4", 2: "3", 3: "3", 4: "4", 5: "3", 6: "2", 7: "1", 8: "2", 9: "2", 10: "4",
    11: "3", 12: "1", 13: "4", 14: "4", 15: "4", 16: "1", 17: "2", 18: "3", 19: "2", 20: "2",
    21: "3", 22: "4", 23: "4", 24: "3", 25: "1 & 3", 26: "4", 27: "4", 28: "2", 29: "1", 30: "2",
    31: "3", 32: "4", 33: "3", 34: "1", 35: "1", 36: "4", 37: "4", 38: "4", 39: "4", 40: "4",
    41: "1", 42: "2", 43: "4", 44: "3", 45: "2", 46: "3", 47: "4", 48: "4", 49: "4", 50: "4"
  },
  Chemistry: {
    1: "2", 2: "3", 3: "1", 4: "2", 5: "4", 6: "3", 7: "4", 8: "3", 9: "2", 10: "2",
    11: "3", 12: "1", 13: "4", 14: "3", 15: "1", 16: "3", 17: "3", 18: "3", 19: "3", 20: "3",
    21: "1", 22: "4", 23: "2", 24: "3", 25: "2", 26: "1", 27: "4", 28: "1", 29: "3", 30: "2",
    31: "3", 32: "4", 33: "2", 34: "1", 35: "3", 36: "3", 37: "2", 38: "2", 39: "3", 40: "2",
    41: "4", 42: "4", 43: "3", 44: "3", 45: "4", 46: "3", 47: "2", 48: "3", 49: "3", 50: "4"
  },
  Biology: {
    1: "6", 2: "2", 3: "4", 4: "4", 5: "1", 6: "1", 7: "1", 8: "2", 9: "1", 10: "3",
    11: "1", 12: "3", 13: "2", 14: "4", 15: "2", 16: "4", 17: "2", 18: "3", 19: "1", 20: "3",
    21: "3", 22: "4", 23: "2", 24: "1", 25: "4", 26: "3", 27: "1", 28: "3", 29: "1", 30: "2",
    31: "4", 32: "4", 33: "3", 34: "1", 35: "1", 36: "3", 37: "4", 38: "3", 39: "4", 40: "1",
    41: "1", 42: "4", 43: "1", 44: "3", 45: "3", 46: "1", 47: "4", 48: "2", 49: "4", 50: "1",
    51: "1", 52: "1", 53: "4", 54: "4", 55: "3", 56: "4", 57: "4", 58: "2", 59: "2", 60: "2",
    61: "4", 62: "2", 63: "1", 64: "3", 65: "4", 66: "2", 67: "1", 68: "1", 69: "2", 70: "3",
    71: "3", 72: "1", 73: "4", 74: "1", 75: "2", 76: "3", 77: "4", 78: "1", 79: "4", 80: "4",
    81: "1", 82: "2", 83: "4", 84: "2", 85: "2", 86: "1", 87: "1", 88: "1", 89: "3", 90: "4",
    91: "3", 92: "1", 93: "1", 94: "2", 95: "2", 96: "2", 97: "2", 98: "3", 99: "3", 100: "3"
  }
}
  },
  // 2025 Tests
  'neet202545': {
    id: 'neet202545',
    testName: 'NEET 2025, Paper Code 45',
    year: '2025',
    examName: 'NEET 2025',
    subject: 'Paper Code 45',
    duration: 3 * 60 * 60,
    totalQuestions: 180,
    storagePath: 'PYQTestSeries/Neet/neet202545',
    backLink: '/test-series/pyq/neet',
    questionCounts: {
  Physics: 45,
  Chemistry: 45,
  Biology: 90,
},
answerKey: {
  Physics: {
    1: "2", 2: "2", 3: "2", 4: "4", 5: "2", 6: "2", 7: "4", 8: "4", 9: "1", 10: "1",
    11: "4", 12: "1", 13: "3", 14: "3", 15: "2", 16: "2", 17: "4", 18: "2", 19: "3", 20: "1",
    21: "4", 22: "2", 23: "2", 24: "3", 25: "3", 26: "3", 27: "1", 28: "4", 29: "2", 30: "3",
    31: "1", 32: "2", 33: "3", 34: "2", 35: "2", 36: "2", 37: "3", 38: "1", 39: "3", 40: "1 & 2",
    41: "2", 42: "3", 43: "3", 44: "4", 45: "2"
  },
  Chemistry: {
    1: "4", 2: "5", 3: "2", 4: "1", 5: "1", 6: "3", 7: "3", 8: "2", 9: "4", 10: "1",
    11: "4", 12: "2", 13: "4", 14: "4", 15: "4", 16: "3", 17: "2", 18: "1 & 2", 19: "1", 20: "1",
    21: "2", 22: "3", 23: "2", 24: "2", 25: "3", 26: "3", 27: "1", 28: "3", 29: "1", 30: "4",
    31: "1", 32: "1", 33: "2", 34: "3", 35: "3", 36: "2", 37: "2", 38: "2", 39: "1", 40: "1",
    41: "3", 42: "1", 43: "4", 44: "1", 45: "4"
  },
  Biology: {
    1: "2", 2: "2", 3: "1", 4: "4", 5: "1", 6: "1", 7: "1", 8: "1", 9: "3", 10: "3",
    11: "4", 12: "2", 13: "3", 14: "4", 15: "4", 16: "3", 17: "4", 18: "4", 19: "2", 20: "1",
    21: "1", 22: "1", 23: "2", 24: "4", 25: "3", 26: "1", 27: "3", 28: "1", 29: "3", 30: "4",
    31: "4", 32: "2", 33: "4", 34: "4", 35: "2", 36: "4", 37: "3", 38: "1", 39: "2", 40: "2",
    41: "4", 42: "2", 43: "2", 44: "3", 45: "2", 46: "1", 47: "3", 48: "1", 49: "4", 50: "1",
    51: "1", 52: "1", 53: "3", 54: "1", 55: "3", 56: "1", 57: "2", 58: "4", 59: "3", 60: "4",
    61: "1", 62: "1", 63: "1", 64: "3", 65: "3", 66: "4", 67: "2", 68: "1", 69: "2", 70: "2",
    71: "2", 72: "2", 73: "1", 74: "2", 75: "2", 76: "2", 77: "2", 78: "2", 79: "4", 80: "3",
    81: "4", 82: "1", 83: "1", 84: "3", 85: "3", 86: "2", 87: "2", 88: "1", 89: "4", 90: "2"
  }
}
  },
  'neet202546': {
    id: 'neet202546',
    testName: 'NEET 2025, Paper Code 46',
    year: '2025',
    examName: 'NEET 2025',
    subject: 'Paper Code 46',
    duration: 3 * 60 * 60,
    totalQuestions: 180,
    storagePath: 'PYQTestSeries/Neet/neet202546',
    backLink: '/test-series/pyq/neet',
    questionCounts: {
  Physics: 45,
  Chemistry: 45,
  Biology: 90,
},
answerKey: {
  Physics: {
    1: "2", 2: "2", 3: "4", 4: "2", 5: "2", 6: "1", 7: "4", 8: "1", 9: "2", 10: "2",
    11: "2", 12: "3", 13: "1", 14: "1&4", 15: "3", 16: "3", 17: "4", 18: "3", 19: "1", 20: "1",
    21: "3", 22: "1", 23: "1", 24: "1", 25: "4", 26: "1", 27: "1", 28: "1", 29: "2", 30: "2",
    31: "1", 32: "1", 33: "1", 34: "1", 35: "2", 36: "4", 37: "3", 38: "3", 39: "1", 40: "1",
    41: "4", 42: "2", 43: "2", 44: "3", 45: "4"
  },
  Chemistry: {
    1: "2", 2: "2", 3: "2", 4: "1", 5: "1", 6: "1", 7: "2", 8: "3", 9: "2", 10: "1",
    11: "1&4", 12: "1", 13: "3", 14: "3", 15: "3", 16: "3", 17: "1", 18: "2", 19: "3", 20: "2",
    21: "1", 22: "4", 23: "4", 24: "4", 25: "4", 26: "2", 27: "4", 28: "4", 29: "3", 30: "2",
    31: "3", 32: "1", 33: "3", 34: "1", 35: "4", 36: "4", 37: "4", 38: "1", 39: "1", 40: "1",
    41: "4", 42: "4", 43: "4", 44: "4", 45: "2"
  },
  Biology: {
    1: "4", 2: "3", 3: "4", 4: "1", 5: "3", 6: "4", 7: "3", 8: "2", 9: "1", 10: "2",
    11: "2", 12: "1", 13: "3", 14: "3", 15: "4", 16: "4", 17: "1", 18: "1", 19: "1", 20: "2",
    21: "1", 22: "4", 23: "1", 24: "1", 25: "1", 26: "4", 27: "2", 28: "2", 29: "3", 30: "2",
    31: "4", 32: "4", 33: "4", 34: "4", 35: "3", 36: "4", 37: "2", 38: "1", 39: "4", 40: "2",
    41: "1", 42: "4", 43: "1", 44: "4", 45: "1", 46: "3", 47: "2", 48: "1", 49: "2", 50: "3",
    51: "3", 52: "1", 53: "3", 54: "4", 55: "1", 56: "1", 57: "3", 58: "4", 59: "3", 60: "4",
    61: "2", 62: "2", 63: "4", 64: "4", 65: "4", 66: "2", 67: "1", 68: "3", 69: "3", 70: "4",
    71: "3", 72: "3", 73: "4", 74: "2", 75: "3", 76: "4", 77: "1", 78: "1", 79: "3", 80: "2",
    81: "1", 82: "3", 83: "4", 84: "2", 85: "4", 86: "1", 87: "1", 88: "1", 89: "1", 90: "2"
  }
}
  },
  'neet202547': {
    id: 'neet202547',
    testName: 'NEET 2025, Paper Code 47',
    year: '2025',
    examName: 'NEET 2025',
    subject: 'Paper Code 47',
    duration: 3 * 60 * 60,
    totalQuestions: 180,
    storagePath: 'PYQTestSeries/Neet/neet202547',
    backLink: '/test-series/pyq/neet',
    questionCounts: {
      Physics: 45,
      Chemistry: 45,
      Biology: 90,
    },
    answerKey: {
      Physics: {
    1: "3", 2: "2", 3: "3", 4: "3", 5: "4", 6: "2", 7: "3", 8: "3", 9: "3", 10: "2",
    11: "3", 12: "4", 13: "1", 14: "1", 15: "4", 16: "3", 17: "2", 18: "4", 19: "1", 20: "2&3",
    21: "4", 22: "3", 23: "1", 24: "4", 25: "3", 26: "1", 27: "3", 28: "1", 29: "4", 30: "2",
    31: "2", 32: "1", 33: "4", 34: "1", 35: "3", 36: "3", 37: "3", 38: "3", 39: "4", 40: "4",
    41: "2", 42: "3", 43: "4", 44: "3", 45: "4"
  },
  Chemistry: {
    1: "4", 2: "3", 3: "1", 4: "3", 5: "2", 6: "2", 7: "3", 8: "1", 9: "3", 10: "2",
    11: "2", 12: "2", 13: "2&3", 14: "1", 15: "4", 16: "2", 17: "4", 18: "1", 19: "4", 20: "1",
    21: "4", 22: "3", 23: "1", 24: "3", 25: "4", 26: "4", 27: "2", 28: "3", 29: "2", 30: "4",
    31: "1", 32: "1", 33: "3", 34: "1", 35: "1", 36: "2", 37: "3", 38: "2", 39: "3", 40: "2",
    41: "2", 42: "2", 43: "4", 44: "4", 45: "3"
  },
  Biology: {
    1: "1", 2: "3", 3: "2", 4: "4", 5: "2", 6: "2", 7: "4", 8: "4", 9: "2", 10: "2",
    11: "1", 12: "3", 13: "4", 14: "2", 15: "3", 16: "4", 17: "2", 18: "4", 19: "2", 20: "1",
    21: "2", 22: "3", 23: "2", 24: "1", 25: "2", 26: "4", 27: "2", 28: "3", 29: "4", 30: "3",
    31: "3", 32: "3", 33: "3", 34: "1", 35: "3", 36: "2", 37: "3", 38: "3", 39: "3", 40: "4",
    41: "2", 42: "3", 43: "2", 44: "1", 45: "1", 46: "2", 47: "1", 48: "3", 49: "4", 50: "3",
    51: "2", 52: "3", 53: "1", 54: "1", 55: "2", 56: "1", 57: "4", 58: "1", 59: "3", 60: "2",
    61: "1", 62: "2", 63: "3", 64: "4", 65: "1", 66: "4", 67: "1", 68: "4", 69: "2", 70: "1",
    71: "3", 72: "3", 73: "1", 74: "3", 75: "2", 76: "3", 77: "1", 78: "4", 79: "4", 80: "2",
    81: "4", 82: "2", 83: "4", 84: "1", 85: "3", 86: "3", 87: "2", 88: "2", 89: "1", 90: "3"
  }
    }
  }
};


// ✅ HELPER FUNCTION: Determine question type for NEET (always MCQ)
export function getNEETQuestionType(questionId, totalQuestions) {
  // NEET pattern: ALL questions are MCQ (single correct answer)
  // No numerical questions in NEET
  return "singleCorrect";
}

// ✅ HELPER FUNCTION: Get subject for NEET based on question number
export function getNEETSubject(questionId, totalQuestions) {
  if (totalQuestions === 180) {
    // 180-question pattern (Old NEET)
    // Physics: 1-45, Chemistry: 46-90, Biology: 91-180
    if (questionId >= 1 && questionId <= 45) return "Physics";
    if (questionId >= 46 && questionId <= 90) return "Chemistry";
    if (questionId >= 91 && questionId <= 180) return "Biology";
  } else if (totalQuestions === 200) {
    // 200-question pattern (New NEET 2021+)
    // Physics: 1-50, Chemistry: 51-100, Biology: 101-200
    if (questionId >= 1 && questionId <= 50) return "Physics";
    if (questionId >= 51 && questionId <= 100) return "Chemistry";
    if (questionId >= 101 && questionId <= 200) return "Biology";
  }
  
  return "Physics"; // Default fallback
}